<template>
  <div class="mt-6 mb-24 md:mx-2" v-if="paymentImages">
    <div class="flex gap-7 h-auto min-h-[70vh] flex-col lg:flex-row mx-5 md:mx-0 mb-24">
      <div class="w-full lg:w-[37%] bg-white rounded-lg shadow-ts1 order-2 lg:order-1 pb-7 lg:pb-0">
        <div key="images">
          <div class="pb-4 border-b border-solid border-gray-300 mt-5">
            <div>
              <p class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-blue font-display font-bold text-xl leading-none">{{ $t('deposit_funds').tTitle() }}</p>
            </div>
          </div>
          <p class="mt-7 text-gray-900 font-semibold text-base mb-5 ltr:ml-5 ltr:md:ml-8 rtl:mr-5 rtl:md:mr-8">{{ $t('please_select_payment_method') }}</p>
          <div class="hidden lg:flex flex-col gap-2 mx-8 items-center">
            <div
              v-for="(img, name) in activePaymentImages"
              @click="selectPaymentMethod(name)"
              :key="img.PSPName"
              class="w-full rounded-lg border border-solid py-3 group relative hover:border-blue max-w-xs cursor-pointer select-none"
              :class="[selected.paymentMethod == name ? 'border-green' : 'border-gray-300']"
            >
              <img
                :src="img.path"
                class="w-40 m-auto h-14"
              />
              <div class="w-full rounded-lg flex items-center justify-center bg-blue bg-opacity-85 absolute inset-0 text-white text-center font-bold text-base transition-all ease-in-out duration-200 opacity-0 group-hover:opacity-100">
                <span>{{ $t(name).tTitle() }}</span>
              </div>
            </div>
          </div>
          <div
            class="mx-5 block lg:hidden"
            id="paymentMethodsCarousel"
          >
            <VueSlickCarousel
              v-bind="carouselSettings"
              class="w-full max-w-[480px]"
            >
              <div
                v-for="(img, name) in activePaymentImages"
                @click="selectPaymentMethod(name)"
                :key="img.PSPName"
              >
                <div
                  class="w-[90%] h-[130px] rounded-lg border border-solid flex items-center justify-center"
                  :class="[selected.paymentMethod == name ? 'border-green' : 'border-gray-300']"
                >
                  <img
                    :src="img.mobile_path"
                    class="w-20 m-auto h-full"
                  />
                </div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-3/4 bg-green bg-opacity-15 rounded-lg shadow-ts1 order-3 lg:order-2 mb-20 lg:mb-0 pb-7 lg:pb-0">
        <div class="pb-4 border-b border-solid border-white mt-5">
          <div class="flex justify-between items-center h-5">
            <p v-if="paymentImages[selected.paymentMethod].Component" class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-green font-display font-bold text-xl leading-none">
              {{ $t(paymentImages[selected.paymentMethod].Component.tLower()) }}
            </p>
            <div class="relative group">
              <a
                v-if="selected.paymentMethod=='bitcoin'"
                href="https://confirmo.notion.site/How-to-Pay-with-Confirmo-38fdc32d561f8045bdd4dc7426007091"
                target="_blank"
                class="h-[34px] w-[148px] bg-blue rounded-md flex justify-center items-center ltr:mr-5 ltr:md:mr-8 rtl:ml-5 rtl:md:ml-8 text-white text-sm"
              >
                {{$t('payment_tutorial')}}
              </a>
              <div class="absolute hidden group-hover:block ltr:right-5 ltr:md:right-8 rtl:left-5 rtl:md:left-8 bottom-[-165px] md:bottom-[-138px] w-[275px] md:w-[330px] bg-white shadow-ts1 rounded-lg py-4 px-5 text-base leading-7 text-gray-900">
                {{$t('payment_tutorial_text')}}
              </div>
            </div>
          </div>
        </div>
        <div
          class="mx-5 md:mx-8 mt-7 pb-6"
          key="component"
        >
          <component
            v-if="paymentImages[selected.paymentMethod]"
            :is="paymentImages[selected.paymentMethod].Component"
            :selected="selected"
            :apm="selected.paymentMethod === 'neteller' ? 'neteller' : null"
          />
          <div class="tile is-12 is-parent">
            <!-- <div
              class="tile is-11 is-parent"
              v-for="(img, name) in selectedPaymentMethod"
              :key="name"
            >
              <div class="tile is-3">
                <figure class="image is-100x100">
                  <img :src="img.path" />
                </figure>
              </div>

              <div class="tile is-9">
                <div>
                  <span
                    class="title"
                    :class="{ 'has-text-right': Language == 'fa', 'has-text-left': Language != 'fa' }"
                  >{{ $t(img.T) }}</span>

                  <article class="tile is-child psp">
                    <component
                      :selected="selected"
                      v-bind:is="paymentImages[selected.paymentMethod].Component"
                      :apm="selected.paymentMethod == 'neteller' ? 'neteller' : null"
                    ></component>
                  </article>
                </div>
              </div>
            </div> -->

            <!-- <div class="tile is-1">
              <div class="topNav">
                <a
                  class="button"
                  @click="step--, (selected.paymentMethod = '')"
                >
                  <span class="icon is-small">
                    <i
                      class="fa fa-chevron-circle-left"
                      :class="{ 'ml-10': Language == 'fa' }"
                    ></i>
                  </span>
                  <span>{{ $t('back') }}</span>
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="w-full lg:w-1/4 flex flex-row lg:flex-col gap-4 md:gap-8 order-1 lg:order-3">
        <div class="w-full h-28 md:h-[8.2rem] bg-white rounded-lg shadow-ts1">
          <div class="h-full flex justify-center ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 flex-col">
            <p class="text-gray-900 text-sm leading-6 font-semibold">{{ $t('wallet_balance').tTitle() }}</p>
            <p class="pt-1 text-blue font-bold text-[1.37rem] md:text-4xl">{{ $formatMoney(walletBalance, currencySymbols[wallet.currency]) }}</p>
          </div>
        </div>
        <div class="w-full h-28 md:h-[8.2rem] bg-white rounded-lg shadow-ts1 relative">
          <div class="h-full flex justify-center ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 flex-col relative">
            <div class="flex justify-between flex-col md:flex-row">
              <p class="text-gray-900 text-sm leading-6 font-semibold">{{ $t('total_deposits').tTitle() }}</p>
              <!-- <div class="absolute top-1 md:top-auto right-0 md:relative">
                <select
                  v-model="selectedCurrency"
                  name="currency"
                  class="w-16 h-5 bg-none bg-transparent text-gray-900 border-0 p-0 rounded-md text-sm md:text-base font-bold appearance-none focus:outline-none focus:ring-0"
                >
                  <option>USD</option>
                  <option>EUR</option>
                </select>
                <div class="select-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div> -->
            </div>
            <p class="pt-1 text-green font-bold text-[1.37rem] md:text-4xl">{{ $formatMoney(totalDeposits, currencySymbols[wallet.currency]) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showMaintenanceModal">
      <div class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full">
        <div class="bg-white rounded-lg w-11/12 lg:w-[642px] max-w-[642px] m-auto relative max-h-[82%] p-10">
          <button
            @click="showMaintenanceModal = false"
            class="bg-white rounded-full h-10 w-10 absolute -top-14 right-0 appearance-none p-0"
          >
            <div class="h-6 w-0.5 bg-blue rotate-45 ml-5"></div>
            <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ml-5"></div>
          </button>
          <p class="text-xl font-bold text-gray-dark mb-4">{{ $t('important_note')}}</p>
          <p
            v-html="$t('confirmo_maintenance_note')"
            class="text-base leading-7 text-gray-dark"
          ></p>
        </div>
      </div>
    </div>

    <div v-if="showMessageModal">
      <div class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full">
        <div class="bg-white rounded-lg w-11/12 lg:w-[642px] max-w-[642px] m-auto relative max-h-[82%] p-10">
          <button
            @click="showMessageModal = false"
            class="bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0"
          >
            <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
            <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
          </button>
          <p class="text-xl font-bold text-red mb-4">{{ $t('important_note')}}</p>
          <p
            v-html="$t('confirmo_message_note')"
            class="text-base leading-7 text-gray-dark"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import RegularPay from './deposit-methods/RegularPay'
// import EpayPro from './deposit-methods/EpayPro'
// import EData from './deposit-methods/EData'
// import Skrill from './deposit-methods/Skrill'
// import Neteller from './deposit-methods/Neteller'
import Bitcoin from './deposit-methods/Bitcoin'
// import KoalaPay from './deposit-methods/KoalaPay'
// import PagoCUP from './deposit-methods/PagoCUP'
// import Fasapay from './deposit-methods/Fasapay'
import BankWire from './deposit-methods/BankWire'
import VLoad from './deposit-methods/VLoad'
import Lydiax from './deposit-methods/Lydiax'
// import SafeCharge from './deposit-methods/SafeCharge'
// import PowerCash from './deposit-methods/PowerCash'
// import axios from 'axios'
import { service } from '../../main.js'
import { mapActions, mapGetters } from 'vuex'
import api from '../../api'
import config from '../../config'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

// import NewTermsModal from '../../components/NewTermsModal'

const imgPath = require.context('../../assets/img/funding', true)

export default {
  props: ['platformImages'],
  components: {
    VueSlickCarousel,
    // RegularPay,
    // EpayPro,
    // EData,
    // Skrill,
    // Neteller,
    Bitcoin,
    // KoalaPay,
    // PagoCUP,
    // Fasapay,
    BankWire,
    VLoad,
    Lydiax,
    // SafeCharge,
    // PowerCash,
    // NewTermsModal,
  },
  data() {
    return {
      selected: {
        paymentMethod: 'bitcoin',
      },
      step: 1,
      paymentImages: null,
      selectedCurrency: '',
      currencySymbols: config.currencies,
      totalDeposits: 0,
      showMaintenanceModal: false,
      showMessageModal: false,
      carouselSettings: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 2,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 430,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    }
  },
  watch: {
    'selected.paymentMethod'() {
      if (this.selected.paymentMethod) {
        this.step = 2
      }
    },
    activePaymentImages: {
      handler(newVal) {
        // null while allowed deposit providers are still loading
        if (!newVal) return
        var resultKeys = Object.keys(newVal)
        if (resultKeys.length === 1) {
          this.selected.paymentMethod = resultKeys[0]
          this.showMessageModal = false
        }
      },
      immediate: true,
    },
  },
  computed: {
    activePaymentImages() {
      if (this.allowedDeposit.length === 0) return null

      if (!this.paymentImages || Object.keys(this.paymentImages).length === 0) {
        return {}
      }

      var tempObj = {}
      var currency = this.wallet && this.wallet.currency ? this.wallet.currency.toUpperCase() : null
      var country = this.User && this.User.info ? this.User.info.country_code.toUpperCase() : null
      const allowedGateways = this.allowedDeposit.filter(provider => provider.allowed).map(provider => provider.gateway.toLowerCase())

      for (const property in this.paymentImages) {
        if (!this.wallet.currency) {
          break
        }

        let item = this.paymentImages[property]

        let PSPCurrencyAllowed = !item.BlockedCurrencies || !item.BlockedCurrencies.length || item.BlockedCurrencies.indexOf(currency) === -1
        let PSPCountryAllowed = !item.BlockedCountries || !item.BlockedCountries.length || (country && item.BlockedCountries.indexOf(country) === -1)
        let PSPUserAllowed = item.PSPName && allowedGateways.indexOf(item.PSPName.toLowerCase()) !== -1

        // bankwire is only shown when the user is allowed it, the rest follow currency/country rules
        let PSPAllowed = property === 'bankwire' ? PSPUserAllowed : PSPCurrencyAllowed && PSPCountryAllowed

        if (PSPAllowed) {
          tempObj[property] = item
        }
      }
      return tempObj
    },
    selectedPaymentMethod() {
      return this.paymentImages.filter(item => this.selected.paymentMethod === item.name)
      // return this.paymentImages.filter((_, name) => name == this.selected.paymentMethod)
    },
    walletBalance() {
      return this.wallet.balance ? Math.floor(this.wallet.balance * 100) / 100 : 0
    },

    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      Finance: 'finance/all',
      logoLoaderActive: 'logoLoader/active',
      wallet: 'user/wallet',
      allowedDeposit: 'finance/allowedDepositProviders',
    }),
  },
  mounted() {
    // Fetch totals data
    this.getTotals(),
      // Fetch wallet data and set it in the store
      api.GetWallet().then(wallet => {
        this['user/setWallet'](wallet)
      }),
      api.GetPSPBlockedCountries().then(blockedCountries => {
        this['finance/setPSPBlockedCountries'](blockedCountries)
      }),
      api.GetAllowedDepositProviders().then(allowedDepositProvider => {
        this['finance/setAllowedDepositProviders'](allowedDepositProvider)
      })

    // check for preselected values
    if (this.Finance.deposit.selected.paymentMethod) {
      this.selected.paymentMethod = this.Finance.deposit.selected.paymentMethod
      this['finance/preSelectedDepositValue']({ key: 'paymentMethod', value: null })
    }

    this.$bus.$on('RequestDeposit', this.requestDeposit)

    if (!this.User.TA.length) {
      // get trading accounts if needed
      api.GetTradingAccounts()
    }

    // PSPs (handling image loading/path)
    // this.paymentImages = this.$store.state.finance.PSPs
    this.paymentImages = Object.assign({}, this.Finance.PSPs)
    let platNames = Object.keys(this.paymentImages)
    for (let i = 0, l = platNames.length; i < l; i++) {
      if (platNames[i] == 'lydiax' && this.User.info.ID === 163901) {
        delete this.paymentImages[platNames[i]]
        continue
      }
      this.paymentImages[platNames[i]]['path'] = imgPath('./' + platNames[i] + '.svg', true)
      this.paymentImages[platNames[i]]['mobile_path'] = imgPath('./' + platNames[i] + '-mob.svg', true)
    }

    this.selectedCurrency = this.User.wallet.currency

    // SHOW CONFIRMO MAINTENANCE MODAL
    // const targetDate = new Date('2025-07-28T09:30:00')
    // const currentDate = new Date()
    // if (currentDate < targetDate && this.selected.paymentMethod === 'bitcoin') {
    //   this.showMaintenanceModal = true
    // }
    // if(this.selected.paymentMethod==='bitcoin'){
    //   this.showMaintenanceModal = true
    // }
    if (this.selected.paymentMethod === 'bitcoin') {
      this.showMessageModal = true
    }
  },
  beforeDestroy() {
    this.$bus.$off('RequestDeposit', this.requestDeposit)
  },
  methods: {
    selectPaymentMethod(name) {
      if (name === 'e-data') {
        this.$toasted.info(this.$t('deposit_info'))
        return
      }
      // if (name === 'bankwire') {
      // 	this.$toasted.info('The bank wire transfer option is temporarily unavailable. Please select another deposit method until a new payment service provider is made available for sending wires.<br><br>We will make all efforts to offer you an alternative bank wire transfer solution as soon as possible.<br><br>We apologize for the inconvenience and greatly appreciate your patience and understanding.<br><br>On the other hand, we have now made available, what we feel is a much more viable alternative solution:<br><br>We have now set up a faster way for you to deposit and withdraw through our KoalaPay Payment Service Provider, without the hassle of the account set up process, as we can take care of setting up the account on your behalf.<br><br>Please send an email to backoffice@plexytrade.com for more details.')
      // 	return
      // }

      // SHOW CONFIRMO MAINTENANCE MODAL
      // if(name==='bitcoin'){
      //   this.showMaintenanceModal = true
      // }
      if (name === 'bitcoin') {
        this.showMessageModal = true
      }
      this.selected.paymentMethod = name
      // const targetDate = new Date('2025-07-28T09:30:00')
      // const currentDate = new Date()
      // if (currentDate < targetDate && this.selected.paymentMethod === 'bitcoin') {
      //   this.showMaintenanceModal = true
      // }
    },
    requestDeposit(url, data, successcb, failedcb) {
      // this['logoLoader/set'](true)
      service
        .post(url, data)
        .then(response => {
          if (!response.data.success) {
            // this['logoLoader/set'](false)
          }
          successcb(response)
        })
        .catch(error => {
          // this['logoLoader/set'](false)
          failedcb(error)
        })
    },
    async getTotals() {
      return service.get('/finance/user/' + this.User.info.ID + '/totals-converted', {}).then(response => {
        if (response.data.total_deposits) {
          for (let i = 0; i < response.data.total_deposits.length; i++) {
            if (response.data.total_deposits[i].currency == this.wallet.currency) {
              this.totalDeposits = response.data.total_deposits[i].value
              break
            }
          }
        }
      })
    },
    ...mapActions(['logoLoader/set', 'finance/preSelectedDepositValue', 'user/setWallet', 'finance/setPSPBlockedCountries', 'finance/setAllowedDepositProviders']),
  },
}
</script>
<style>
#paymentMethodsCarousel .slick-dots {
  text-align: left;
}
</style>
